import { RestrictedSidebarUserMenu } from "@/components/sidebar/RestrictedSidebarUserMenu.tsx";
import { useEmployeeMe } from "@/queries/employees/use-employees.query.ts";
import { useAppTheme } from "@/themes/app-context.ts";
import { Box, SidebarRail, SidebarRailItemData } from "@skailer-com/uikit";
import { useNavigate } from "react-router-dom";

/** Стабильная пустая ссылка: литерал `[]` в пропе менял бы зависимости useMemo рельса каждый рендер. */
const NO_ITEMS: SidebarRailItemData[] = [];

export function RestrictedSidebar() {
  const sidebarTheme = useAppTheme("sidebar");
  const { data: employee } = useEmployeeMe();
  const navigate = useNavigate();

  return (
    <SidebarRail
      items={NO_ITEMS}
      className={sidebarTheme.menu.base}
      logo={
        <Box
          className={"w-8 h-8 rounded-xs overflow-hidden relative cursor-pointer"}
          onClick={() => navigate("/preboarding")}
        >
          <img
            src={employee?.organization.logo_url || "/favicon-96x96.png"}
            className={"w-8 h-8"}
          />
        </Box>
      }
      footer={<RestrictedSidebarUserMenu />}
    />
  );
}
